module.exports = __webpack_public_path__ + "img/5_75.7d7944a2.png";